<script>
import countlyVue from '../../compat/vue-core';
import i18n from '../../../../i18n';

export default countlyVue.components.BaseComponent.extend({
  props: {
    diff: {
      type: Array,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    emitSaveWhenDisabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    noMessage: {
      type: Boolean,
      required: false,
      default: false,
    },
    customMode: {
      type: Boolean,
      required: false,
      default: false,
    },
    mode: {
      type: String,
      required: false,
    },
  },
  computed: {
    hasDiff() {
      return this.diff.length > 0;
    },
    madeChanges() {
      return i18n.tc('common.diff-helper.changes', this.diff.length);
    },
  },
  methods: {
    save() {
      if (this.disabled && !this.emitSaveWhenDisabled) {
        return;
      }
      this.$emit('save');
    },
    discard() {
      this.$emit('discard');
    },
  },
});
</script>
<template>
  <div
    v-if="hasDiff"
    class="cly-vue-diff-helper"
  >
    <slot name="main">
      <div
        v-if="!noMessage"
        class="message"
      >
        <span class="text-dark">{{ madeChanges }}</span>
        <span class="text-dark">&nbsp;{{ $t("common.diff-helper.keep") }}</span>
      </div>
      <div class="buttons">
        <el-button
          v-if="!customMode"
          skin="light"
          class="discard-btn"
          type="secondary"
          @click="discard"
        >
          {{ $t('common.discard-changes') }}
        </el-button>
        <el-button
          v-if="!customMode"
          skin="green"
          class="save-btn"
          :disabled="disabled"
          type="success"
          @click="save"
        >
          {{ $t('common.save-changes') }}
        </el-button>
        <el-button
          v-if="customMode"
          :disabled="disabled"
          @click="save"
        >
          {{ $t(`common.${mode}`) }}
        </el-button>
      </div>
    </slot>
  </div>
</template>
